import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { SharedService } from 'src/app/Service/shared.service';

@Component({
  selector: 'app-lexique',
  templateUrl: './lexique.component.html',
  styleUrls: ['./lexique.component.scss']
})
export class LexiqueComponent implements OnInit {
  lexiques =[];
  alphabet = 'A';
  currentLg ;
  alphArray = [];

  constructor(private global: Global,  private shared: SharedService, private router: Router) { }
  
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.currentLg = lg;
      this.alphArray = this.genCharArray('a', 'z');
      if(lg.code.toUpperCase() === 'FR') {
        this.shared.getLexique(lg.url).subscribe(datas => {
          this.lexiques = datas['value'];
        })
      } else {
        this.router.navigate(['/']);
      }
    });
  }
  genCharArray(charA, charZ) {
    let a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
    for (; i <= j; ++i) {
        a.push(String.fromCharCode(i));
    }
    return a;
}

}
